
import React, { useState, useEffect } from 'react';
import { dateService } from '../../services/dateService';
import { reservationService } from '../../services/reservationService';
import { Link } from 'react-router-dom';

const AdminPanel = () => {
    const [blockedDates, setBlockedDates] = useState([]);
    const [customPrices, setCustomPrices] = useState({});
    const [reservations, setReservations] = useState([]);

    // Range State
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [price, setPrice] = useState('');

    // Reservation Form State
    const [resName, setResName] = useState('');
    const [resCheckIn, setResCheckIn] = useState('');
    const [resCheckOut, setResCheckOut] = useState('');
    const [resGuests, setResGuests] = useState(2);
    const [resPrice, setResPrice] = useState('');

    const [password, setPassword] = useState('');
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        if (isAuthenticated) {
            loadData();
        }
    }, [isAuthenticated]);

    const loadData = () => {
        setBlockedDates(dateService.getBlockedDates());
        setCustomPrices(dateService.getCustomPrices());
        setReservations(reservationService.getReservations());
    };

    // --- Range Handlers ---

    const handleBlockRange = (e) => {
        e.preventDefault();
        if (!startDate || !endDate) return alert('Selecione data inicial e final');
        dateService.blockRange(startDate, endDate);
        loadData();
        setStartDate(''); setEndDate('');
        alert('Período bloqueado!');
    };

    const handleUnblockRange = (e) => {
        e.preventDefault();
        if (!startDate || !endDate) return alert('Selecione data inicial e final');
        dateService.unblockRange(startDate, endDate);
        loadData();
        setStartDate(''); setEndDate('');
        alert('Período desbloqueado!');
    };

    const handleSetPrice = (e) => {
        e.preventDefault();
        if (!startDate || !endDate || !price) return alert('Preencha datas e valor');
        dateService.setPriceRange(startDate, endDate, price);
        loadData();
        setStartDate(''); setEndDate(''); setPrice('');
        alert('Preço definido!');
    };

    // --- Reservation Handlers ---

    const handleAddReservation = (e) => {
        e.preventDefault();
        if (!resName || !resCheckIn || !resCheckOut) {
            alert('Preencha nome e datas');
            return;
        }

        reservationService.addReservation({
            guestName: resName,
            checkIn: resCheckIn,
            checkOut: resCheckOut,
            guests: resGuests,
            totalPrice: resPrice
        });

        loadData();
        // Clear form
        setResName('');
        setResCheckIn('');
        setResCheckOut('');
        setResPrice('');
        alert('Reserva criada com sucesso!');
    };

    const handleDeleteReservation = (id) => {
        if (window.confirm('Tem certeza que deseja cancelar esta reserva? As datas serão desbloqueadas.')) {
            reservationService.removeReservation(id);
            loadData();
        }
    };

    const handleDateClick = (date) => {
        if (window.confirm(`Deseja desbloquear a data ${new Date(date).toLocaleDateString()}?`)) {
            // Unblock single date logic (using unblockRange for single day)
            dateService.unblockRange(date, date);
            loadData();
        }
    };

    // --- Auth ---

    const handleLogin = (e) => {
        e.preventDefault();
        if (password === 'admin123') setIsAuthenticated(true);
        else alert('Senha incorreta');
    };

    if (!isAuthenticated) {
        return (
            <div className="admin-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="admin-card" style={{ maxWidth: '400px', width: '100%', margin: '0 20px' }}>
                    <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Acesso Administrativo</h2>
                    <form onSubmit={handleLogin}>
                        <div className="admin-input-group" style={{ marginBottom: '20px' }}>
                            <input type="password" placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} />
                        </div>
                        <button type="submit" className="admin-btn btn-price" style={{ width: '100%' }}>Entrar</button>
                    </form>
                    <div style={{ marginTop: '20px', textAlign: 'center' }}>
                        <Link to="/" style={{ color: '#fff', textDecoration: 'none', opacity: 0.8 }}>← Voltar para Home</Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-container">
            <header className="admin-header">
                <div className="admin-header-content">
                    <h1>Painel Admin - Cabanas de Vidro</h1>
                    <Link to="/" className="admin-back-link">Ir para o Site</Link>
                </div>
            </header>

            <div className="admin-content">

                {/* --- SEÇÃO DE RESERVAS --- */}
                <div className="admin-card">
                    <h3>Nova Reserva (Painel de Locação)</h3>
                    <p>Adicione uma reserva manual. Isso bloqueará as datas automaticamente.</p>
                    <form onSubmit={handleAddReservation}>
                        <div className="admin-form-row">
                            <div className="admin-input-group">
                                <label>Nome do Hóspede:</label>
                                <input type="text" value={resName} onChange={(e) => setResName(e.target.value)} placeholder="Ex: João Silva" required />
                            </div>
                            <div className="admin-input-group">
                                <label>Hóspedes:</label>
                                <select value={resGuests} onChange={(e) => setResGuests(e.target.value)} style={{ width: '100%', padding: '14px', background: 'rgba(0,0,0,0.3)', border: '1px solid rgba(255,255,255,0.15)', color: '#fff', borderRadius: '8px' }}>
                                    {[1, 2, 3, 4].map(n => <option key={n} value={n} style={{ color: '#000' }}>{n}</option>)}
                                </select>
                            </div>
                            <div className="admin-input-group">
                                <label>Valor Total (R$):</label>
                                <input type="number" value={resPrice} onChange={(e) => setResPrice(e.target.value)} placeholder="Opcional" />
                            </div>
                        </div>
                        <div className="admin-form-row">
                            <div className="admin-input-group">
                                <label>Check-in:</label>
                                <input type="date" value={resCheckIn} onChange={(e) => setResCheckIn(e.target.value)} required />
                            </div>
                            <div className="admin-input-group">
                                <label>Check-out:</label>
                                <input type="date" value={resCheckOut} onChange={(e) => setResCheckOut(e.target.value)} required />
                            </div>
                        </div>
                        <div className="admin-actions">
                            <button type="submit" className="admin-btn btn-price" style={{ width: '100%' }}>Criar Reserva</button>
                        </div>
                    </form>
                </div>

                <div className="admin-card">
                    <h3>Reservas Ativas ({reservations.length})</h3>
                    <div className="data-list-container">
                        <div className="data-list">
                            {reservations.length === 0 ? <p className="empty-msg">Nenhuma reserva registrada.</p> : (
                                <div>
                                    {reservations.sort((a, b) => new Date(a.checkIn) - new Date(b.checkIn)).map(res => (
                                        <div key={res.id} className="data-item booking-item">
                                            <div>
                                                <strong>{res.guestName}</strong> <span style={{ opacity: 0.7 }}>({res.guests} pessoas)</span><br />
                                                <small style={{ color: 'var(--primary-color)' }}>
                                                    {new Date(res.checkIn).toLocaleDateString()} - {new Date(res.checkOut).toLocaleDateString()}
                                                </small>
                                                {res.totalPrice && <span style={{ marginLeft: '10px', color: '#81c784' }}>R$ {res.totalPrice}</span>}
                                            </div>
                                            <button onClick={() => handleDeleteReservation(res.id)} className="btn-icon-delete" title="Cancelar Reserva">
                                                ✕
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* --- SEÇÃO DE BLOQUEIOS E PREÇOS --- */}
                <div className="admin-card">
                    <h3>Gerenciar Datas e Preços (Avulso)</h3>
                    <p>Bloqueie períodos sem criar reserva ou defina preços personalizados.</p>

                    <div className="admin-form-row">
                        <div className="admin-input-group">
                            <label>Data Inicial:</label>
                            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                        </div>
                        <div className="admin-input-group">
                            <label>Data Final:</label>
                            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                        </div>
                        <div className="admin-input-group">
                            <label>Diária (R$):</label>
                            <input type="number" value={price} onChange={(e) => setPrice(e.target.value)} />
                        </div>
                    </div>

                    <div className="admin-actions">
                        <button onClick={handleBlockRange} className="admin-btn btn-block">Reservar</button>
                        <button onClick={handleUnblockRange} className="admin-btn btn-unblock">Cancelar Reserva</button>
                        <button onClick={handleSetPrice} className="admin-btn btn-price">Definir Valor</button>
                    </div>
                </div>

                <div className="admin-grid">
                    <div className="admin-card">
                        <h3>Datas Reservadas ({blockedDates.length})</h3>
                        <p style={{ fontSize: '0.9rem', marginBottom: '10px' }}>Clique em uma data para desbloquear.</p>
                        <div className="data-list-container">
                            <div className="data-list">
                                {blockedDates.length === 0 ? <p className="empty-msg">Nenhuma data reservada.</p> : (
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', padding: '15px' }}>
                                        {blockedDates.sort().map(date => (
                                            <div
                                                key={date}
                                                className="date-tag blocked"
                                                onClick={() => handleDateClick(date)}
                                                title="Clique para desbloquear"
                                            >
                                                {new Date(date).toLocaleDateString()}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="admin-card">
                        <h3>Preços Personalizados ({Object.keys(customPrices).length})</h3>
                        <div className="data-list-container">
                            <div className="data-list">
                                {Object.keys(customPrices).length === 0 ? <p className="empty-msg">Nenhum preço definido.</p> : (
                                    <div>
                                        {Object.keys(customPrices).sort().map(date => (
                                            <div key={date} className="data-item">
                                                <span>{new Date(date).toLocaleDateString()}</span>
                                                <strong>R$ {customPrices[date]}</strong>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default AdminPanel;
